'use client';

import { Shield } from 'lucide-react';
import { useEffect, useState } from 'react';

export function ImpersonateBanner() {
  const [handler, setHandler] = useState<string | null>(null);

  useEffect(() => {
    setHandler(sessionStorage.getItem('impersonating'));
  }, []);

  useEffect(() => {
    if (!handler) return;
    // Real rendered height: py-1.5 (12px) + text-sm line-height (20px) = 32px.
    document.documentElement.style.setProperty('--impersonate-offset', '32px');
    return () => {
      document.documentElement.style.setProperty('--impersonate-offset', '0px');
    };
  }, [handler]);

  if (!handler) return null;

  return (
    <div className="sticky top-0 left-0 right-0 z-99999 flex items-center justify-center gap-2 bg-amber-700 px-4 py-1.5 text-sm font-medium text-white">
      <Shield className="size-4" />
      You are impersonating @{handler}
    </div>
  );
}
